export var mobile = Object.freeze({
    max: 767,
});
export var tablet = Object.freeze({
    min: 768,
    max: 1023,
});
export var desktop = Object.freeze({
    min: 1024,
});
export var wideScreen = Object.freeze({
    min: 1276,
});
